import { match } from 'ts-pattern'
import { Severity } from '../../utils/api-client/api-schemas.ts'
import * as styles from './severity-badge.css.ts'

type SeverityBadgeProps = {
  severity: Severity | null | undefined
  isAnalyzed?: boolean
}

export const SeverityBadge: React.FC<SeverityBadgeProps> = ({ severity, isAnalyzed = true }) => {
  const text = match(severity)
    .with(null, () => 'Unknown')
    .otherwise(() => severity?.label ?? 'Unknown')

  const color = match(severity?.rank)
    .with(undefined, () => 'unknown' as const)
    .with(0, () => 'unknown' as const)
    .when(
      n => n >= 0 && n <= 25,
      () => 'low' as const
    )
    .when(
      n => n > 25 && n <= 50,
      () => 'medium' as const
    )
    .when(
      n => n > 50 && n <= 75,
      () => 'high' as const
    )
    .when(
      n => n > 75,
      () => 'critical' as const
    )
    .otherwise(() => 'unknown' as const)

  return (
    <span
      className={styles.badge[color]}
      data-severity={color}
      style={isAnalyzed === false ? { opacity: 0.5 } : undefined}
    >
      {capitalize(text)}
    </span>
  )
}

const capitalize = (str: string) => str.charAt(0).toUpperCase() + str.slice(1)
